/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import ZoneItems from './ZoneItems';
import BasicParagraphPSWorld from './PWSupportingComponents/BasicParagraphPSWorld';


const ZoneSectionModule = ({
  handlerSetComponents, components, id, reusableComponent, languages, activeLanguage,
}) => {
  const initialState = {
    type: 'ZoneSection',
    intro: {
      title: '+1 Zone',
      text: {
        en: '',
        es: '',
        ca: '',
        pt: '',
      },
    },
    zones: [],
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);

  const handlerSetStreamZones = (zones) => {
    const newState = {
      ...state,
      zones,
    };
    setState(newState);
    const componentObj = {
      id,
      component: newState,
    };
    handlerSetComponents(componentObj, index);
  };


  const inputHandler = (e, section) => {
    const { value, name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [section]: {
        ...component[section],
        [name]: value,
      },
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const inputHandlerByLanguage = (contentHtml, name, lang, section) => {
    const { component } = components[index];

    const comp = {
      ...component,
      [section]: {
        ...component[section],
        [name]: {
          ...component[section][name],
          [lang.toLowerCase()]: contentHtml,
        },
      },
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const handleInputIntro = (contentHtml, lang) => {
    if (index >= 0) {
      inputHandlerByLanguage(contentHtml, 'text', lang, 'intro');
    }
  };


  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      setIsLoading(false);
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  return (
    <>
      <div className="w-full px-5 rounded-lg flex flex-row pt-4 pb-4">
        <div className="pl-9 w-full">

          <div className="bg-greyFilter w-full sm:w-full md:w-full p-4">
            <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="title">
              General title
              <input
                className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm"
                onChange={e => (inputHandler(e, 'intro'))}
                name="title"
                type="text"
                value={(state && state.hasOwnProperty('intro') && state.intro.title) || ''}
              />
            </label>
          </div>

          <BasicParagraphPSWorld
            title="General description"
            handleInput={handleInputIntro}
            activeLanguage={activeLanguage}
            languages={languages}
            stateField={(state && state.hasOwnProperty('intro') && state.intro.text) || undefined}
          />

          <h2 className="w-full font-americaMonoRegular text-xs uppercase text-black mt-4 mb-2">
            Zone +1 objects
          </h2>
          {(!isLoading || state.zones.length) && <ZoneItems handlerSetComponentsInParent={handlerSetStreamZones} components={state.zones} languages={languages} activeLanguage={activeLanguage} />}
        </div>

      </div>

    </>

  );
};

ZoneSectionModule.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
ZoneSectionModule.defaultProps = {
  reusableComponent: null,
};

export default ZoneSectionModule;
